
import React, { useState } from 'react';
import { getAuth, updatePassword } from 'firebase/auth';
import app from '../firebase';

const auth = getAuth(app);

export default function CambiarClave() {
  const [nuevaClave, setNuevaClave] = useState('');
  const [confirmarClave, setConfirmarClave] = useState('');
  const [mensaje, setMensaje] = useState('');
  const [error, setError] = useState('');

  const handleActualizarClave = async (e) => {
    e.preventDefault();
    setMensaje('');
    setError('');

    if (nuevaClave !== confirmarClave) {
      setError('Las contraseñas no coinciden.');
      return;
    }

    try {
      await updatePassword(auth.currentUser, nuevaClave);
      setMensaje('Contraseña actualizada correctamente.');
      setNuevaClave('');
      setConfirmarClave('');
    } catch (err) {
      setError('Error al actualizar la contraseña. Reautenticación requerida.');
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: '2rem auto', textAlign: 'center' }}>
      <h2>Cambiar Contraseña</h2>
      <form onSubmit={handleActualizarClave}>
        <input
          type="password"
          placeholder="Nueva Contraseña"
          value={nuevaClave}
          onChange={(e) => setNuevaClave(e.target.value)}
          required
          style={{ display: 'block', margin: '10px auto', width: '100%' }}
        />
        <input
          type="password"
          placeholder="Confirmar Contraseña"
          value={confirmarClave}
          onChange={(e) => setConfirmarClave(e.target.value)}
          required
          style={{ display: 'block', margin: '10px auto', width: '100%' }}
        />
        {mensaje && <p style={{ color: 'green' }}>{mensaje}</p>}
        {error && <p style={{ color: 'red' }}>{error}</p>}
        <button type="submit">Actualizar</button>
      </form>
    </div>
  );
}
